module.exports = __webpack_public_path__ + "img/MacOS_logo.24b06264.svg";